import { useContext } from "react";
import { useHistory } from "react-router";
import { hideModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";
import "./ModalAlertGrupoFamiliar.css";

const ModalAlertGrupoFamiliar = () => {
  const { modalDispatch } = useContext(PortalContext);
  const history = useHistory();
  return (
    <div className="ptur-ModalAlertGrupoFamiliar-container">
      <div className="ptur-ModalAlertGrupoFamiliar-header bgcG-danger rb16m">
        No tienes derechos para realizar esta acción.
      </div>
      <div className="ptur-ModalAlertGrupoFamiliar-body">
        <span className="rbrb16">
          ¿Desea agregar el derecho para{" "}
          <span className="rb16xl">poder realizar esta acción?</span>
        </span>
        <div className="ptur-ModalAlertGrupoFamiliar-containerBtn">
          <button onClick={() => hideModal()(modalDispatch)} className="rb16m">
            Volver
          </button>
          <button
            onClick={() => {
              history.push("/GrupoFamiliar");
              hideModal()(modalDispatch);
            }}
            className="rb16m"
          >
            Ir a mi grupo familiar
          </button>
        </div>
      </div>
    </div>
  );
};
export default ModalAlertGrupoFamiliar;
